import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AuthorizedLayout from '@/layouts/AuthorizedLayout.vue';
import { onBeforeMount, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { getters } = useStore();
const isLoggedIn = computed<boolean>(() => getters['auth/isLoggedIn']);

const router = useRouter();

onBeforeMount(async () => {
	if (isLoggedIn.value) {
		await router.push({ name: 'MeasurementListPage' });
	}
});
watch(
	() => getters['auth/isLoggedIn'],
	async (newVal, oldVal) => {
		if (newVal && newVal !== oldVal) {
			await router.push({ name: 'MeasurementListPage' });
		}
	},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthorizedLayout, { title: "HOMEPAGE" }))
}
}

})